import React, { useState } from 'react';
import TogglerBody from '../../TogglerBody'
import TipsTamplate from '../../TipsTamplate';
import ChooseActionTamplate from '../../actionTamplate/ChooseActionTamplate';
import {statusActions} from '../../../../constants/common'

import './statusTamplate.scss'

const StatusAntiNukeTamplate = ({data}) => {
    const [isOnMonitor, setIsOnMonitor] = useState(data?.data?.enabled);
    const [isOnPunish, setIsOnPunish] = useState(data?.data?.applyPunishment);
    const [currentAction, setCurrentAction] = useState(data?.data?.punishment || "Kick");
    
    return (
        <div className='status_block_wrap' style={{maxHeight:'330px'}}>
            <div className='status_block_wrap_bg'></div>
            <img  className='status_block_wrap_img' src="/img/StatusBlock.svg" alt="" />
            <h3>Status</h3>
            <div 
            className='status_block_item'
            style={{borderBottom:'1px solid #8D99A3'}}
            >
            <div className='status_block_item_toggler'>
                <TogglerBody isOn={isOnMonitor} setIsOn={setIsOnMonitor} keyName={"enabled"} />
                <p>Monitor Webhooks</p>
            </div>
            </div>
            <div 
            className='status_block_item'
            >
                <div className='status_block_item_toggler'>
                    <TogglerBody isOn={isOnPunish} setIsOn={setIsOnPunish} keyName={"applyPunishment"} />
                    <div className='white_list_block_item_title_block flag_customisation_item_wrap_title'>
                <p>Apply Punishment</p>
                <TipsTamplate
                    title={'Global Punishment'}
                    label={'Safe'}
                    text={'<p>Punishment represents what Themis does once this flag is triggered and the total amount of flags accumulated by the member surpasses the limit.</p>'}
                    textSecond={'<p>Punishment type and sensitivity can be override using Advanced Settings</p>'}
                    />
                </div>
                </div>
                <ChooseActionTamplate
                    keyName={"punishment"}
                    currentAction={currentAction}
                    setCurrentAction={setCurrentAction}
                    actionArr={statusActions}
                    />
            </div>
            {/* <div className='status_block_item'>
                <div className='status_block_item_toggler'>
                    <TogglerBody
                    isOn={isOnPunish}
                    setIsOn={setIsOnPunish}
                    />
                    <p>Use Rulesets</p>
                </div>
                    <div className='input_checkbox_user_wrap'>
                        {userList.map((item, id) => (
                            
                            <InputCheckBoxUser
                            key={id}
                            item={item}
                            // setCheckBox={setCheckBox}
                            // checkBox={checkBox}
                            />
                        ))
                        }
                    </div>

            </div> */}
        </div>
    );
};

export default StatusAntiNukeTamplate;